import { ERoomType, IJsonQuery } from '../../../../packages/api-models/common/json_query';

const NON_FLAT_ROOMS = [ERoomType.Room, ERoomType.Bed, ERoomType.FlatShared];

export function isFlatSearch(jsonQuery: IJsonQuery) {
  const operationalJsonQuery = jsonQuery;

  const type = operationalJsonQuery._type;
  const rooms = operationalJsonQuery.room && operationalJsonQuery.room.value;

  const doRoomsSuite = Array.isArray(rooms) ? !NON_FLAT_ROOMS.some(el => rooms.includes(el)) : true;

  return typeof type !== 'undefined' && (type.includes('flat') || type.includes('newobject')) && doRoomsSuite;
}
